const RECOMMENDED_PERCENTAGE_THRESHOLD = 80;

const getRecommendedPercentage = (totalReviewCount = 0, recommendedCount = 0) => {
    if (!totalReviewCount || totalReviewCount <= 0) {
        return null;
    }

    return Math.min(100, Math.round((100 * recommendedCount) / totalReviewCount));
};

const shouldShowRecommendedPercentage = percentage => percentage !== null && percentage >= RECOMMENDED_PERCENTAGE_THRESHOLD;

export {
    getRecommendedPercentage, shouldShowRecommendedPercentage, RECOMMENDED_PERCENTAGE_THRESHOLD
};
